import React from "react";
import { FaBoxOpen, FaBuilding } from "react-icons/fa";
import { TextInput } from "../atoms";
import { Stepper } from "../shared";
import { STEPS } from "./constants";

const STEP_ITEMS = [
  {
    key: STEPS.CONFIG,
    label: "Ürün & Anlaşma",
    description: "Ürün ve makine seçin, anlaşmayı hazırlayın",
  },
  {
    key: STEPS.CALCULATION,
    label: "Hesaplama",
    description: "Maliyet girdilerini tamamlayın",
  },
  {
    key: STEPS.PDF,
    label: "PDF & Paylaşım",
    description: "Sonuçları kontrol edin, PDF indirin",
  },
];

export default function OfferFlowHero({
  selectedCount,
  brandName,
  currentStep,
  onBrandNameChange,
}) {
  const totalSteps = STEP_ITEMS.length;
  const normalizedStep = Math.min(Math.max(currentStep, 1), totalSteps);
  const activeStep = STEP_ITEMS[normalizedStep - 1];

  return (
    <div className="bg-white border border-gray-200 rounded-2xl shadow-sm p-4 sm:p-6 space-y-5">
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div>
          <p className="text-[11px] font-semibold tracking-wider text-indigo-500 uppercase">
            Adım {normalizedStep} / {totalSteps}
          </p>
          <h2 className="text-lg sm:text-xl font-bold text-gray-900 mt-1">
            {activeStep.label}
          </h2>
          <p className="text-sm text-gray-500 mt-0.5">
            {activeStep.description}
          </p>
        </div>

        <div className="flex items-center gap-2">
          <div className="flex items-center gap-2 bg-indigo-50/80 border border-indigo-100/80 rounded-lg px-3 py-2">
            <FaBoxOpen className="w-4 h-4 text-indigo-500 shrink-0" />
            <span className="text-base font-bold text-indigo-800">
              {selectedCount}
            </span>
            <span className="text-xs text-indigo-500 font-medium hidden sm:inline">
              Seçili Ürün
            </span>
          </div>
          <div className="flex items-center gap-2 bg-amber-50/80 border border-amber-100/80 rounded-lg px-3 py-2 max-w-[220px]">
            <FaBuilding className="w-4 h-4 text-amber-500 shrink-0" />
            <span className="text-sm font-bold text-amber-800 truncate">
              {brandName || "Marka belirlenmedi"}
            </span>
          </div>
        </div>
      </div>

      <div className="overflow-x-auto">
        <div className="min-w-[320px]">
          <Stepper
            steps={STEP_ITEMS.map((step) => step.label)}
            current={normalizedStep}
          />
        </div>
      </div>

      {onBrandNameChange && (
        <div className="max-w-sm">
          <TextInput
            value={brandName}
            onChange={(e) => onBrandNameChange(e.target.value)}
            placeholder="Örn. Bayıner Cafe"
            label="Marka / Firma Adı"
            wrapperClassName="!space-y-2"
          />
        </div>
      )}
    </div>
  );
}
